package top.wcpe.allincore.dsl.compiler.lex

import top.wcpe.allincore.dsl.compiler.source.SourcePosition
import top.wcpe.allincore.dsl.compiler.source.SourceRange

/**
 * 词法 token。
 *
 * @property type token 类型
 * @property lexeme 原始或归一化后的字符串（STRING/STRING_PART 为已解码文本，其余为原文）
 * @property position token 起始位置
 * @property literalValue 字面量解析后的值（STRING/NUMBER/BOOLEAN 时为 [String]/[Number]/[Boolean]，其它为 null）
 */
data class Token(
    val type: TokenType,
    val lexeme: String,
    val position: SourcePosition,
    val literalValue: Any?,
    /** token 在原始源码中的 UTF-16 左闭右开范围。 */
    val range: SourceRange,
) {
    /** 恢复既有三参数源码与 JVM 构造器兼容，字面量默认值为 null。 */
    constructor(type: TokenType, lexeme: String, position: SourcePosition) :
        this(type, lexeme, position, null, defaultRange(type, lexeme, position))

    /** 保留既有 JVM 四参数构造器。 */
    constructor(type: TokenType, lexeme: String, position: SourcePosition, literalValue: Any?) :
        this(type, lexeme, position, literalValue, defaultRange(type, lexeme, position))

    companion object {
        private fun defaultRange(type: TokenType, lexeme: String, position: SourcePosition): SourceRange {
            if (position.sourceId.isEmpty() || position.offset < 0) return SourceRange.NONE
            val end = if (type == TokenType.EOF) position.offset else position.endOffset.coerceAtLeast(position.offset + lexeme.length)
            return SourceRange(position.sourceId, position.offset, end)
        }
    }
}
